import { Component } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { ListeVendeursComponent } from 'src/app/tableaux-listes/liste-vendeurs/liste-vendeurs.component';
import { FormVendeurComponent } from '../page-entites/form-vendeur/form-vendeur.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-page-vendeurs',
  templateUrl: './page-vendeurs.component.html',
  imports: [ListeVendeursComponent,DialogModule,ToastModule,FormVendeurComponent,ButtonModule],
  styleUrls: ['./page-vendeurs.component.scss']
})
export class PageVendeursComponent {

  userForm: boolean = false;

  showVendeur() {
    // this.messageService.add({ severity: 'success', detail: 'L’utilisateur Benoit ARVISET a bien été crée.' });
    this.userForm = true;
  }

  cancel() {

  }

}
